
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteI as ObiOwnShipRemoteIElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-i.js';
 
 
 

 
 export const ObiOwnShipRemoteI = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-i',
   elementClass: ObiOwnShipRemoteIElement,
   events: {
     
   }
  });
 
 